"use strict";

var _interopRequireDefault = require("/root/workspace/merchant_5Yxh/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es6.regexp.split");
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.set");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.array.from");
require("core-js/modules/web.dom.iterable");
var _regeneratorRuntime2 = _interopRequireDefault(require("/root/workspace/merchant_5Yxh/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/merchant_5Yxh/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.number.constructor");
var _toConsumableArray2 = _interopRequireDefault(require("/root/workspace/merchant_5Yxh/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
var _interopRequireWildcard2 = _interopRequireDefault(require("/root/workspace/merchant_5Yxh/node_modules/@babel/runtime-corejs2/helpers/interopRequireWildcard.js"));
var _system = require("@/api/system");
var _auth = require("@/utils/auth");
var _settingMer = _interopRequireDefault(require("@/libs/settingMer"));
var _aliOss = _interopRequireDefault(require("ali-oss"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'Upload',
  props: {
    isMore: {
      type: String,
      default: '1'
    },
    changeType: {
      type: String,
      default: '1'
    },
    // eslint-disable-next-line vue/require-default-prop
    setModel: {
      type: String
    },
    changeCategory: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      loading: false,
      params: '',
      sleOptions: {
        attachment_category_name: '',
        attachment_category_id: ''
      },
      list: [],
      grid: {
        xl: 3,
        lg: 6,
        md: 6,
        sm: 8,
        xs: 24
      },
      grid2: {
        xl: 21,
        lg: 18,
        md: 18,
        sm: 16,
        xs: 24
      },
      filterText: '',
      treeData: [],
      treeData2: [],
      defaultProps: {
        children: 'children',
        label: 'attachment_category_name'
      },
      classifyId: 0,
      myHeaders: {
        'X-Token': (0, _auth.getToken)()
      },
      tableData: {
        page: 1,
        limit: 20,
        attachment_category_id: 0,
        order: '',
        attachment_name: ''
      },
      pictrueList: {
        list: [],
        total: 0
      },
      isShowPic: false,
      checkPicList: [],
      ids: [],
      checkedMore: [],
      checkedAll: [],
      selectItem: [],
      editId: '',
      // 记录id
      editName: '',
      // 记录保存前名字
      showUpload: false,
      uploadImgList: [],
      ossClient: null,
      changeCate: null
    };
  },
  computed: {
    fileUrl: function fileUrl() {
      return _settingMer.default.https + "/upload/image/".concat(this.tableData.attachment_category_id, "/file");
    }
  },
  watch: {
    filterText: function filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  mounted: function mounted() {
    var _this = this;
    (0, _system.getUploadOssStsToken)().then(function (res) {
      // eslint-disable-next-line no-undef
      _this.ossClient = new _aliOss.default({
        region: res.data.region,
        accessKeyId: res.data.Credentials.AccessKeyId,
        accessKeySecret: res.data.Credentials.AccessKeySecret,
        stsToken: res.data.Credentials.SecurityToken,
        bucket: res.data.bucket
      });
    }).catch(function (msg) {
      console.log(msg);
    });
    this.params = this.$route && this.$route.path ? this.$route.path : '';
    if (this.$route && this.$route.query.field === 'dialog') {
      Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require("../../../public/UEditor/dialogs/internal"));
      });
    }
    this.getList();
    this.getFileList('');
  },
  methods: {
    // 搜索分类
    filterNode: function filterNode(value, data) {
      if (!value) return true;
      return data.attachment_category_name.indexOf(value) !== -1;
    },
    // 所有分类
    getList: function getList() {
      var _this2 = this;
      var data = {
        attachment_category_name: '全部图片',
        attachment_category_id: 0
      };
      (0, _system.formatLstApi)().then(function (res) {
        _this2.treeData = res.data;
        _this2.treeData.unshift(data);
        _this2.treeData2 = (0, _toConsumableArray2.default)(_this2.treeData);
      }).catch(function (res) {
        // this.$message.error(res.message);
      });
    },
    // 编辑图片名称
    handleEdit: function handleEdit(id, name) {
      var _this3 = this;
      if (id === this.editId) {
        if (this.editName !== name) {
          if (!name.trim()) {
            this.$message.warning('请先输入图片名称');
            return;
          }
          (0, _system.picNameEditApi)(id, {
            attachment_name: name
          }).then(function () {
            return _this3.getFileList('');
          });
          this.editId = '';
        } else {
          this.editId = '';
          this.editName = '';
        }
      } else {
        this.editId = id;
        this.editName = name;
      }
    },
    // 添加分类
    onAdd: function onAdd(id) {
      var _this4 = this;
      var config = {};
      if (Number(id) > 0) config.formData = {
        pid: id
      };
      this.$modalForm((0, _system.attachmentCreateApi)(), config).then(function (_ref) {
        var message = _ref.message;
        // this.$message.success(message)
        _this4.getList();
      });
    },
    // 编辑
    onEdit: function onEdit(id) {
      var _this5 = this;
      this.$modalForm((0, _system.attachmentUpdateApi)(id)).then(function () {
        return _this5.getList();
      });
    },
    // 删除
    handleDelete: function handleDelete(id) {
      var _this6 = this;
      this.$modalSure().then(function () {
        (0, _system.attachmentDeleteApi)(id).then(function (_ref2) {
          var message = _ref2.message;
          _this6.$message.success(message);
          _this6.getList();
        }).catch(function (_ref3) {
          var message = _ref3.message;
        });
      });
    },
    handleNodeClick: function handleNodeClick(data) {
      this.changeCate = data;
      this.tableData.attachment_category_id = data.attachment_category_id;
      this.getFileList('');
    },
    // 上传成功
    handleSuccess: function handleSuccess(response) {
      if (response.status === 200) {
        this.$message.success('上传成功');
        this.getFileList('');
      } else {
        this.$message.error(response.message);
      }
      this.$refs.uploadImg.clearFiles();
    },
    // 文件列表
    getFileList: function getFileList(num) {
      var _this7 = this;
      this.loading = true;
      this.tableData.page = num || this.tableData.page;
      (0, _system.attachmentListApi)(this.tableData).then( /*#__PURE__*/function () {
        var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(res) {
          return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _this7.pictrueList.list = res.data.list;
                // console.log(this.pictrueList.list);
                if (_this7.pictrueList.list.length) {
                  _this7.isShowPic = false;
                } else {
                  _this7.isShowPic = true;
                }
                if (_this7.$route && _this7.$route.query.field && _this7.$route.query.field !== 'dialog') {
                  _this7.checkedMore = window.form_create_helper.get(_this7.$route.query.field) || [];
                }
                _this7.pictrueList.total = res.data.count;
                _this7.loading = false;
              case 5:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref4.apply(this, arguments);
        };
      }()).catch(function (res) {
        // this.$message.error(res.message);
        _this7.loading = false;
      });
    },
    pageChange: function pageChange(page) {
      this.tableData.page = page;
      this.selectItem = [];
      this.checkPicList = [];
      this.getFileList('');
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableData.limit = val;
      this.getFileList('');
    },
    // 选中图片
    changImage: function changImage(item, index, row) {
      var _this8 = this;
      // this.$set(item, 'isSelect', item.isSelect === undefined ? true : !item.isSelect)
      // selectItem = this.pictrueList.list.filter((item) => {
      //   return item.isSelect === true
      // })
      // this.ids = []
      // const pic = []
      // selectItem.map((item, index) => {
      //   this.ids.push(item.attachment_id)
      //   pic.push(item.attachment_src)
      // })
      // this.checkPicList = pic

      var cType = '1';
      if (this.$route && this.$route.query && this.$route.query.item_type) {
        cType = this.$route.query.item_type || '1';
      } else {
        cType = this.changeType;
      }
      if (cType === '1' && item.attachment_type !== 1) {
        this.$message.error('不能选择视频文件，请选择图片');
        return false;
      } else if (cType === '2' && item.attachment_type !== 2) {
        this.$message.error('不能选择图片，请选择视频文件');
        return false;
      }
      if (!item.isSelect) {
        item.isSelect = true;
        this.selectItem.push(item);
        this.checkPicList.push(item.attachment_src);
        this.ids.push(item.attachment_id);
      } else {
        // this.checkPicList.push(item.attachment_src)
        item.isSelect = false;
        var index = this.ids.indexOf(item.attachment_id);
        if (index > -1) this.ids.splice(index, 1);
        // this.ids = []
        this.selectItem.forEach(function (o, i) {
          if (o.attachment_id == item.attachment_id) {
            _this8.selectItem.splice(i, 1);
          }
        });
        this.checkPicList.map(function (el, index) {
          if (el == item.attachment_src) {
            _this8.checkPicList.splice(index, 1);
          }
        });
      }
      if (!this.$route || this.$route.fullPath !== '/merchant/config/picture' || this.$route.query.field === 'dialog') {
        this.pictrueList.list.map(function (el, i) {
          if (el.isSelect) {
            _this8.selectItem.filter(function (el2, j) {
              if (el.attachment_id == el2.attachment_id) {
                el.num = j + 1;
              }
            });
          } else {
            el.num = 0;
          }
        });
      }
      // console.log(this.pictrueList.list);
    },
    selectAll: function selectAll() {
      var _this9 = this;
      this.selectItem = [];
      this.checkPicList = [];
      this.ids = [];
      this.pictrueList.list.forEach(function (item) {
        item.isSelect = true;
        _this9.selectItem.push(item);
        _this9.checkPicList.push(item.attachment_src);
        _this9.ids.push(item.attachment_id);
      });
    },
    // 点击使用选中图片
    checkPics: function checkPics() {
      if (this.checkPicList.length) {
        // console.log(this.$route);
        if (this.$route) {
          if (this.$route.query.type === '1') {
            if (this.checkPicList.length > 1) {
              return this.$message.warning('最多只能选一个');
            }
            /* eslint-disable */
            form_create_helper.set(this.$route.query.field, this.checkPicList[0]);
            form_create_helper.close(this.$route.query.field);
          }
          if (this.$route.query.type === '2') {
            this.checkedAll = [].concat((0, _toConsumableArray2.default)(this.checkedMore), (0, _toConsumableArray2.default)(this.checkPicList));
            form_create_helper.set(this.$route.query.field, Array.from(new Set(this.checkedAll)));
            form_create_helper.close(this.$route.query.field);
          }
          if (this.$route.query.field === 'dialog') {
            var str = '';
            for (var i = 0; i < this.checkPicList.length; i++) {
              str += '<img src="' + this.checkPicList[i] + '">';
            }
            /* eslint-disable */
            nowEditor.editor.execCommand('insertHtml', str);
            nowEditor.dialog.close(true);
          }
        } else {
          if (this.isMore === '1' && this.checkPicList.length > 1) {
            return this.$message.warning('最多只能选一个');
          }
          if (Number(this.isMore) > 1 && Number(this.isMore) < this.checkPicList.length) {
            return this.$message.warning('最多可选择' + Number(this.isMore) + '个');
          }
          this.$emit('getImage', this.checkPicList);
        }
      } else {
        this.$message.warning('请先选择内容');
      }
    },
    checkCategory: function checkCategory() {
      if (!this.changeCate || !this.changeCate.attachment_category_id) {
        this.$message.warning('请先选择左侧分类');
        return false;
      }
      this.$emit('getImage', this.changeCate);
    },
    // 删除图片
    editPicList: function editPicList(tit) {
      var _this10 = this;
      var ids = {
        ids: this.ids
      };
      this.$modalSure().then(function () {
        (0, _system.picDeleteApi)(ids).then(function (_ref5) {
          var message = _ref5.message;
          _this10.$message.success(message);
          _this10.getFileList('');
          _this10.checkPicList = [];
          _this10.ids = [];
        }).catch(function (_ref6) {
          var message = _ref6.message;
        });
      });
    },
    // 移动分类点击
    handleSelClick: function handleSelClick(node) {
      if (this.ids.length) {
        this.sleOptions = {
          attachment_category_name: node.attachment_category_name,
          attachment_category_id: node.attachment_category_id
        };
        this.getMove();
      } else {
        this.$message.warning('请先选择图片');
      }
    },
    getMove: function getMove() {
      var _this11 = this;
      (0, _system.categoryApi)(this.ids, this.sleOptions.attachment_category_id).then( /*#__PURE__*/function () {
        var _ref7 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2(res) {
          return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                _this11.$message.success(res.message);
                _this11.clearBoth();
                _this11.getFileList('');
              case 3:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        return function (_x2) {
          return _ref7.apply(this, arguments);
        };
      }()).catch(function (res) {
        _this11.clearBoth();
        // this.$message.error(res.message);
      });
    },
    clearBoth: function clearBoth() {
      this.sleOptions = {
        attachment_category_name: '',
        attachment_category_id: ''
      };
      this.checkPicList = [];
      this.ids = [];
    },
    modeUpload: function modeUpload(file) {
      var f = file.file;
      if (f.type.indexOf('image') === -1 && f.type.indexOf('video') === -1) {
        return;
      }
      if (f.type.indexOf('image') !== -1 && f.size / 1024 / 1024 > 15) {
        this.$message.error('图片不能超过15M');
        return false;
      }
      f.uploadStatus = 0;
      f.progress = 0;
      f.tempCheckpoint = false;
      if (f.size / 1024 / 1024 > 1) {
        f.showSize = "".concat(Number(f.size / 1024 / 1024).toFixed(2), " MB");
      } else {
        f.showSize = "".concat(Number(f.size / 1024).toFixed(2), " KB");
      }
      this.uploadImgList = this.uploadImgList.concat([f]);
      if (this.showUpload) return false;
      this.showUpload = true;
      this.uploadALiAction();
    },
    uploadALiAction: function uploadALiAction() {
      var _this12 = this;
      if (!this.loading_icon) {
        this.loading_icon = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      }
      if (this.uploadImgList[0]) {
        this.multipartUpload(this.uploadImgList[0], function (result) {
          _this12.uploadImgList.splice(0, 1);
          _this12.uploadALiAction();
        });
      } else {
        this.showUpload = false;
        if (this.loading_icon) {
          this.loading_icon.close();
          this.loading_icon = null;
        }
        this.getFileList('');
      }
    },
    multipartUpload: function () {
      var _multipartUpload = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3(m, cb) {
        var mer_id, options, myDate, imgType, imgT, imgName, imgUrl, result;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              mer_id = localStorage.getItem('mer_id');
              _context3.prev = 1;
              options = {
                callback: {
                  // 设置回调请求的服务器地址，例如http://oss-demo.aliyuncs.com:23450。
                  url: _settingMer.default.https + '/system/OssCallback',
                  //（可选）设置回调请求消息头中Host的值，即您的服务器配置Host的值。
                  //host: 'yourCallbackHost',
                  // 设置发起回调时请求body的值。
                  body: 'filename=${object}&size=${size}&mimeType=${mimeType}&height=${imageInfo.height}&width=${imageInfo.width}' + '&attachment_name=${x:attachment_name}' + '&binduid=${x:mer_id}' + '&attachment_category_id=${x:attachment_category_id}' + '&attachment_type=${x:attachment_type}' + '&token=${x:token}',
                  // 设置发起回调请求的Content-Type。
                  contentType: 'application/x-www-form-urlencoded',
                  // 设置发起回调请求的自定义参数。
                  customValue: {
                    attachment_category_id: "".concat(this.tableData.attachment_category_id || 0),
                    mer_id: "".concat(mer_id),
                    attachment_type: "".concat(m.type.indexOf('video') === -1 ? 1 : 2),
                    attachment_name: m.name,
                    token: (0, _auth.getToken)()
                  }
                }
              };
              myDate = new Date();
              imgType = m.name.split('.');
              imgT = imgType[imgType.length - 1];
              imgT = imgT.toLowerCase();
              imgName = myDate.getTime().toString() + parseInt(Math.random() * 1000000, 10).toString();
              imgUrl = "".concat(imgName, ".").concat(imgT);
              _context3.next = 11;
              return this.ossClient.put("merchant/".concat(mer_id || '000000', "/").concat(myDate.getFullYear()).concat(myDate.getMonth() + 1).concat(myDate.getDate(), "/").concat(m.type.indexOf('video') === -1 ? 'image' : 'video', "/").concat(imgUrl), m, options);
            case 11:
              result = _context3.sent;
              if (result && result.name) {
                cb(result);
              }
              _context3.next = 18;
              break;
            case 15:
              _context3.prev = 15;
              _context3.t0 = _context3["catch"](1);
              if (cb) cb();
            case 18:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[1, 15]]);
      }));
      function multipartUpload(_x3, _x4) {
        return _multipartUpload.apply(this, arguments);
      }
      return multipartUpload;
    }()
  }
};
exports.default = _default;